import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import styled from 'styled-components';

import { theme } from '@notino/react-styleguide';

import { variantsMessages } from './messages';

const StyledUnavailable = styled.p`
  ${theme.typography.labelSmall400}
  color: ${theme.color.text.secondary}
`;

export const Unavailable = () => {
  return (
    <StyledUnavailable>
      <FormattedMessage {...variantsMessages.unavailable} />
    </StyledUnavailable>
  );
};
